const pjson = require('../../package.json');

export const environment = {
    production: false,
    version: pjson.version,
    server: {
        protocol: 'https',
        host: 'api.staging.tuti.education',
        port: 443,
        apiPath: 'api/'
    },
    websocket: {
        host: 'api.staging.tuti.education',
        port: 443
    },
    appTitle: "Tutì Video Staging",
    configuration: <any>{},
    swarmifyLoaded: false,
    webDeviceUUID: "",
    gtag: {
        enabled: false,
        gtmIframeID: "GTM-XXXXXXX",
        config1: "G-XXXXXXXXXX",
        config2: "G-YYYYYYYYYY"
    },
    iuBenda: {
        enabled: false,
        script1: {
            text: ``
        },
        script2: {
            src: ``
        }
    }
};